/* eslint-disable @typescript-eslint/no-empty-interface, @typescript-eslint/no-misused-promises,
class-methods-use-this */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import { AxiosResponse } from 'axios';
import withRouter from '../../hooks/withRouter';

import {
  JobTitle,
  JobTitleFormSubmitHandler,
  JobTitleResponse,
  CandidateJobTitlesProps,
  CandidateJobTitlesState,
  CandidateJobTitlesViewRendererProps,
} from './types';
import API from '../../network';
import ViewRenderer from './views';
import { AddCandidateJobTitle } from './components';
import { AddATSPropType, UpdateATSPropType } from '../Skills/types';

class CandidateJobTitles extends Component
  <CandidateJobTitlesProps, CandidateJobTitlesState> {
  constructor(props: CandidateJobTitlesProps) {
    super(props);

    this.state = {
      jobTitles: [],
      filterJobTitles: [],
      jobTitlesFetching: true,
    };
  }

  componentDidMount() {
    this.getAllJobTitles();
  }

  getAllJobTitles = () => {
    this.setState(
      {
        jobTitlesFetching: true,
        jobTitles: [],
        filterJobTitles: [],
      },
      async () => {
        try {
          const response: AxiosResponse<JobTitleResponse[]> = await
          API.getInstance().fetchJobTitles();
          const eventsData: JobTitleResponse[] = response.data;
          this.setState({
            jobTitles: eventsData,
            filterJobTitles: eventsData,
          });
        } catch (e) {
          await confirmWrapper('Something went wrong', {
            hideSecondaryBtn: true,
            variant: 'danger',
          });
        } finally {
          this.setState({
            jobTitlesFetching: false,
          });
        }
      },
    );
  };

  createJobTitle = async (data: JobTitleFormSubmitHandler): Promise<void> => {
    const { values } = data;
    try {
      const request: AddATSPropType = {
        type: 'TITLE',
        value: values?.value,
      };
      await API.getInstance().addATSProperty(request);
      this.getAllJobTitles();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  updateJobTitle = async (data: JobTitleFormSubmitHandler): Promise<void> => {
    const { values } = data;
    const { value, id } = values;
    const request: UpdateATSPropType = {
      id,
      type: 'TITLE',
      value,
    };
    try {
      await API.getInstance().updateATSProperty(request);
      this.getAllJobTitles();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  showCreateJobTitle = async () => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      containerClasses: 'p-0',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddCandidateJobTitle
        disabled
        readOnly
        onCreateJobTitle={this.createJobTitle}
      />,
    });
  };

  onEditRow = async (data: JobTitle) => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      showCloseButton: true,
      containerClasses: 'p-0',
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddCandidateJobTitle
        defaultValues={data}
        disabled
        readOnly
        onCreateJobTitle={this.updateJobTitle}
      />,
    });
  };

  onChange = (searchString: string) => {
    const { jobTitles } = this.state;
    const filteredObjects = jobTitles.filter(({ value }) => value && value.toLowerCase()
      .includes(searchString.toLowerCase()));
    this.setState({
      filterJobTitles: filteredObjects,
    });
  };

  getProps = (): CandidateJobTitlesViewRendererProps => {
    const {
      jobTitles,
      jobTitlesFetching,
      filterJobTitles,
    } = this.state;

    return {
      jobTitles,
      jobTitlesFetching,
      filterJobTitles,
      showCreateJobTitle: this.showCreateJobTitle,
      onEditRow: this.onEditRow,
      onChange: this.onChange,
    };
  };

  render() {
    const viewProps: CandidateJobTitlesViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(CandidateJobTitles);
